import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import Imgix from "../core/Imgix";

class Slider {
    constructor(el) {
        const imgixInstance = new Imgix(); // register new Imgix instance

        this.element = el;
        this.imagesRequested = false;
        this.swiper = null;

        this.options = {
            modules: [Navigation, Pagination],
            loop: true,
            slidesPerView: "auto",
            effect: "fade",
            centeredSlides: true,
            pagination: {
                el: ".swiper-pagination",
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            on: {
                slideChange: (swiper) => {
                    if (this.imagesRequested) return;
                    if (!swiper.el) return;

                    var sliderItemImage = swiper.el.querySelector(
                        ".o-slider__item-image"
                    );
                    if (!sliderItemImage) return;

                    var imgElement = sliderItemImage.querySelector("img");
                    if (!imgElement) return;

                    // Load all images on first interaction
                    imgixInstance.process(imgElement);
                    this.imagesRequested = true;
                },
            },
        };

        const classList = this.element.parentElement.classList;

        switch (true) {
            case classList.contains("c-slider--marquee"):
                // add autoplay to existing modules
                // this.options.modules.push(Autoplay);

                // add new options
                Object.assign(this.options, {
                    modules: [Navigation, Autoplay],
                    speed: 2500,
                    effect: null,
                    centeredSlides: false,
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: null,
                        prevEl: null,
                    },
                    pagination: false,
                });

                this.marqueeSlider(this.options);
                break;
            case classList.contains("c-slider--hero"):
                Object.assign(this.options, {
                    modules: [Navigation],
                    loop: false,
                    freeMode: true,
                    spaceBetween: 10,
                    centeredSlides: false,
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: false,
                    },
                    breakpoints: {
                        640: {
                            spaceBetween: 10,
                        },
                        1024: {
                            spaceBetween: 20,
                        },
                    },
                });

                this.heroSlider(this.options);
                break;
            case classList.contains("c-slider--captions"):
                Object.assign(this.options, {
                    modules: [],
                    loop: false,
                    freeMode: true,
                    spaceBetween: 10,
                    centeredSlides: false,
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: false,
                    },
                    breakpoints: {
                        640: {
                            spaceBetween: 10,
                        },
                        1024: {
                            spaceBetween: 20,
                        },
                    },
                });
                this.defaultSlider(this.options);
                break;
            case classList.contains("c-slider--downloads"):
                Object.assign(this.options, {
                    modules: [Navigation, Pagination],
                    loop: false,
                    freeMode: true,
                    spaceBetween: 20,
                    centeredSlides: false,
                    centerInsufficientSlides: true,
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: false,
                    },
                    breakpoints: {
                        640: {
                            spaceBetween: 20,
                        },
                        1024: {
                            spaceBetween: 24,
                        },
                    },
                });

                this.heroSlider(this.options);
                break;

            default:
                this.defaultSlider(this.options);
                break;
        }
    }

    defaultSlider($options) {
        Swiper.use(Navigation);

        this.swiper = new Swiper(this.element, $options);
    }

    marqueeSlider($options) {
        Swiper.use(Navigation);

        this.swiper = new Swiper(this.element, $options);

        if (this.swiper.navigation) {
            this.swiper.navigation.disable();
        }

        this.swiper.update();
    }

    heroSlider($options) {
        Swiper.use(Navigation);

        this.swiper = new Swiper(this.element, $options);
    }
}

export default Slider;
